export default function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-scale/src/colors.js
// module id = 18
// module chunks = 0